import React from 'react'
import { makeStyles } from '@material-ui/core/styles'
import { themeConWeb } from '@app/util/modernThemeConweb'

const useStyles = makeStyles({
  wrapper: {
    display: 'flex',
    alignItems: 'center',
    position: 'relative',
    height: '20px',
  },
  dot: {
    position: 'relative',
    width: '10px',
    height: '10px',
    borderRadius: '50%',
    backgroundColor: ({ active }) =>
      active ? themeConWeb.color.brandPrimary : themeConWeb.color.greyShade1,
    marginLeft: '20px',
  },
})

const Dot = ({ active }) => {
  const classes = useStyles({ active })
  return <div className={classes.dot} />
}

const DottedProgress = ({ currentStep, totalSteps }) => {
  const classes = useStyles()
  return (
    <div className={classes.wrapper}>
      {[...Array(totalSteps)].map((v, index) => (
        <Dot key={index} active={currentStep - 1 === index} />
      ))}
    </div>
  )
}

export default DottedProgress
